import { Link } from 'react-router-dom';
import { GalleryItem } from '../data/gallery';
import { useLanguage } from '../contexts/LanguageContext';
import { translate } from '../i18n';

const ArtworkCard = ({ artwork }: { artwork: GalleryItem }) => {
  const { locale } = useLanguage();
  const coverImage = artwork.media[0]?.url;
  const authorName = artwork.author ? artwork.author.name[locale] || artwork.author.name.en : '';

  return (
    <article className="artwork-card">
      <Link
        className="artwork-card__link"
        to={`/artwork/${artwork.slug}`}
        aria-label={`${artwork.title[locale]} — ${translate(locale, 'viewDetails')}`}
      >
        {coverImage ? (
          <div className="artwork-card__image">
            <img src={coverImage} alt={artwork.title[locale]} loading="lazy" />
          </div>
        ) : null}
        <div className="artwork-card__body">
          <header>
            <h3>{artwork.title[locale]}</h3>
            <p className="artwork-card__year">
              {translate(locale, 'yearLabel')}: {artwork.year}
            </p>
          </header>
          <p className="artwork-card__description">{artwork.description[locale]}</p>
          <ul className="artwork-card__tags">
            {artwork.tags.map((tag) => (
              <li key={tag.id}>{tag.label[locale]}</li>
            ))}
          </ul>
        </div>
      </Link>
      {artwork.author ? (
        <div className="artwork-card__footer">
          <span className="artwork-card__meta-label">{translate(locale, 'authorLabel')}:</span>{' '}
          <Link className="artwork-card__author" to={`/authors?authorId=${artwork.author.id}`}>
            {authorName}
          </Link>
        </div>
      ) : null}
    </article>
  );
};

export default ArtworkCard;
